var providerDefaultLogo = 'https://s3.amazonaws.com/uniteus-io-assets/logos/groups/default.png';
export default providerDefaultLogo;